import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Wrapper = styled.main`
  flex: 1;
  width: 100%;
  background: #fafbfc;
`

export const Container = styled.div`
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  padding: 54px 0 70px;

  @media (max-width: 720px) {
    width: calc(100% - 28px);
    padding: 30px 0 44px;
  }
`

export const PageHeader = styled.header`
  max-width: 780px;
  display: flex;
  align-items: flex-start;
  gap: 18px;
`

export const HeaderIcon = styled.div`
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #fff0f0;
  color: #e90000;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 20px;
  }

  @media (max-width: 560px) {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
`

export const Eyebrow = styled.div`
  color: #e90000;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Title = styled.h1`
  margin: 5px 0 8px;
  color: #202633;
  font-size: clamp(27px, 4vw, 38px);
  line-height: 1.08;
`

export const Description = styled.p`
  max-width: 680px;
  margin: 0;
  color: #737b87;
  font-size: 14px;
  line-height: 1.65;
`

export const Toolbar = styled.div`
  margin: 34px 0 24px;
  padding: 14px;
  border: 1px solid #e5e8ed;
  border-radius: 15px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  box-shadow: 0 8px 26px rgba(35, 42, 52, 0.035);

  @media (max-width: 620px) {
    margin-top: 24px;
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
`

export const SearchBox = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 560px;
  height: 46px;
  padding: 0 14px;
  border: 1px solid #dfe3e8;
  border-radius: 11px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fafbfc;
  color: #8d949e;

  &:focus-within {
    border-color: rgba(233, 0, 0, 0.35);
    box-shadow: 0 0 0 3px rgba(233, 0, 0, 0.06);
  }

  svg {
    flex: 0 0 auto;
    font-size: 14px;
  }
`

export const Input = styled.input`
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: #303641;
  font-size: 13px;

  &::placeholder {
    color: #a0a6af;
  }
`

export const ResultCount = styled.div`
  flex: 0 0 auto;
  color: #858c97;
  font-size: 11px;

  strong {
    color: #2d333d;
    font-size: 13px;
  }
`

export const UserWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
    gap: 11px;
  }
`

export const UserContainer = styled(Link)`
  min-width: 0;
  min-height: 154px;
  padding: 20px;
  border: 1px solid #e5e8ed;
  border-radius: 16px;
  background: #fff;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  color: inherit;
  box-shadow: 0 7px 22px rgba(35, 42, 52, 0.025);
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    color: inherit;
    border-color: rgba(233, 0, 0, 0.16);
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(35, 42, 52, 0.07);
  }

  @media (max-width: 620px) {
    min-height: 132px;
    padding: 16px;
  }
`

export const ProfileImageContainer = styled.div`
  flex: 0 0 auto;
  width: 68px;
  height: 68px;
  padding: 2px;
  border: 2px solid #e90000;
  border-radius: 50%;
  background: #fff;

  @media (max-width: 620px) {
    width: 58px;
    height: 58px;
  }
`

export const ProfileIcon = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
  object-fit: cover;
`

export const UserInfo = styled.div`
  min-width: 0;
  flex: 1;
`

export const UserTitle = styled.div`
  overflow: hidden;
  color: #252b35;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const VerifiedIcon = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  color: #df0b0b;
  font-size: 13px;
  vertical-align: middle;
`

export const UserSummary = styled.p`
  min-height: 42px;
  margin: 8px 0 13px;
  overflow: hidden;
  color: #7a828e;
  font-size: 11px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const ProfileCta = styled.span`
  color: #e90000;
  font-size: 10px;
  font-weight: 800;
`

export const EmptyState = styled.div`
  min-height: 240px;
  border: 1px dashed #dfe3e8;
  border-radius: 16px;
  background: #fff;
  color: #8b929c;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  text-align: center;

  svg {
    margin-bottom: 4px;
    color: #bbc0c7;
    font-size: 25px;
  }

  strong {
    color: #505762;
    font-size: 14px;
  }

  span {
    font-size: 11px;
  }
`

export const BackButton = styled(Link)`
  width: fit-content;
  margin-top: 30px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #717986;
  font-size: 11px;
  font-weight: 700;

  &:hover {
    color: #e90000;
  }
`
